module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318880.b77e6144.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318880.pdf
// module id = 848
// module chunks = 0